module.exports = __webpack_public_path__ + "static/media/bitcoin.2f90fea3.svg";